import React from "react";
import "./InfoBlocks.css";
import { LiaWaveSquareSolid } from "react-icons/lia";

const InfoBlocks = ({ title, subtitle, blocks ,end}) => {
    return (
        <div className="info-blocks-section">
            <h2 className="info-blocks-title">{title}</h2>
            {
                subtitle &&
                <h2 className="info-blocks-subtitle">{subtitle}</h2>
            }

            <div className="info-blocks-content">
                {blocks.map((block, i) => (
                    <div key={i} className="info-block-card">
                        {block.title && (
                            <h3 className="info-block-card-title">{block.title}</h3>
                        )}
                        {block.subtitle && (
                            <p className="info-block-card-subtitle">{block.subtitle}</p>
                        )}

                        <ul className="info-block-list">
                            {block.items.map((item, idx) => {
                                const Icon = item.icon || LiaWaveSquareSolid;

                                return (
                                    <li key={idx} className="info-block-item">
                                        <div className="info-block-icon">
                                            {typeof Icon === "string" ? Icon : <Icon />}
                                        </div>

                                        <div className="info-block-text">
                                            {item.title && (
                                                <div className="info-block-item-title">{item.title}</div>
                                            )}
                                            {item.text && (
                                                <div className="info-block-description">{item.text}</div>
                                            )}
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                ))}
            </div>

            {
                end &&
                <h2>{end}</h2>
            }
        </div>
    );
};

export default InfoBlocks;
